import React from "react";

import { Redirect, Route, RouteComponentProps } from "react-router-dom";

import { FrameWrapper } from "components/layout/FrameWrapper";
import { DecarbonizationProfile } from "../admin/Decarbonization/DecarbonizationProfile";
import { ChatBox } from "./ChatBox";
import { Store } from "./Store";
import { VirtualTour } from "./VirtualTour";

export const FramesRouter = ({ match: { path } }: RouteComponentProps) => {
  return (
    <FrameWrapper>
      <Route exact path={`${path}/simulator`}>
        <Redirect to="/solutions/simulator" />
      </Route>

      <Route
        path={`${path}/decarbonization-profile`}
        component={DecarbonizationProfile}
      />

      <Route path={`${path}/alga-ai`} component={ChatBox} />
      <Route path={`${path}/store`} component={Store} />
      <Route path={`${path}/virtual-tour`} component={VirtualTour} />
    </FrameWrapper>
  );
};
